// extracted by mini-css-extract-plugin
module.exports = {"title":"index_title__3buBw","app":"index_app__1782g","table":"index_table__2xNk8"};